/**
 * Button hover: cursor-origin fill
 * Pairs with button-fill.css.
 * Moves the ::before fill circle to the cursor's entry point and grows it,
 * then shrinks it toward the exit point. Uses capture-phase listeners on the
 * document so buttons added later (quick view, cart drawer, AJAX) just work.
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SELECTOR = '.m-button--primary, .m-button--secondary, .m-button--white';
  var EXCLUDE = '.m-button--icon, .m-button--link, .m-button--blank, .m-button--plain, .m-button--scroll-top, .m-button--fixed';
  var BASE_SIZE = 20; // must match --m-fill-size in button-fill.css

  function fillButton(e) {
    var el = e.target;
    if (!(el instanceof Element)) return null;
    if (!el.matches(SELECTOR) || el.matches(EXCLUDE)) return null;
    return el;
  }

  function localPos(btn, e) {
    var r = btn.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width, h: r.height };
  }

  // Scale needed to cover the button from any point: full diagonal as the radius.
  function coverScale(p) {
    return Math.ceil((Math.hypot(p.w, p.h) * 2) / BASE_SIZE);
  }

  document.addEventListener(
    'mouseenter',
    function (e) {
      var btn = fillButton(e);
      if (!btn) return;
      var p = localPos(btn, e);

      // 1. jump the circle to the entry point with no transition
      btn.setAttribute('data-fill-jump', '');
      btn.style.setProperty('--m-fill-x', p.x + 'px');
      btn.style.setProperty('--m-fill-y', p.y + 'px');
      btn.style.setProperty('--m-fill-scale', '0');

      // 2. force the browser to apply that state now
      void btn.offsetWidth;

      // 3. re-enable the transition and grow
      btn.removeAttribute('data-fill-jump');
      btn.style.setProperty('--m-fill-scale', String(coverScale(p)));
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (e) {
      var btn = fillButton(e);
      if (!btn) return;
      var p = localPos(btn, e);

      // re-centre on the exit point, then collapse toward it
      btn.style.setProperty('--m-fill-x', p.x + 'px');
      btn.style.setProperty('--m-fill-y', p.y + 'px');
      btn.style.setProperty('--m-fill-scale', '0');
    },
    true
  );
})();
